<template>
  <div class="personal">
    <ax-header></ax-header>
    <div class="content-box">
      <el-container>
        <el-aside class="aside-box" width="200px">
          <h4>个人中心</h4>
          <div class="nav-box">
            <ul>
              <li v-for="(item, index) in navData" :key="index"
              :class="{'li-active' : activeLi == item.id }"
              @click="handleNavClick(item)">{{item.lable}}</li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import axheader from '../../components/AXheader.vue'
import {
  userInfo,
  UserOrderList
} from '../../api/api'
export default {
  name: 'personalCenter',
  components: {
    'ax-header': axheader
  },
  filters:{
    userType(val){
      if(val == 0){
        return '经销商'
      } else if(val == 1){
        return '服务商'
      } else if(val == 2){
        return '合伙人'
      } else if(val == 3){
        return '工程师'
      } else if(val == 4){
        return '导购员'
      }
    },
    orderType(val){
      if(val == 10){
        return '待付款'
      } else if(val == 20){
        return '商品正在出库'
      } else if(val == 30){
        return '已发货'
      } else if(val == 40){
        return '已收货'
      } else if(val == 50){
        return '已完成'
      } else if(val == 60){
        return '已取消'
      } else if(val == 70){
        return '已关闭'
      }
    }
  },
  data(){
    return{
      activeLi: 1,
      activeName: '1',
      goodsData: [],
      userData: {},
      orderList: [],
      navData: [
        {
          id: 1,
          lable: '我的订单',
          routerUrl: '/user'
        },{
          id: 2,
          lable: '退换货',
          routerUrl: '/user/returnOrExchange'
        },
      ]
    }
  },
  created(){
    this.watchRouter()
    this.getUserInfo()
    this.getUserOrderList()
  },
  methods:{
    handleNavClick(v){
      this.activeLi = v.id
      this.$router.push({
        path: v.routerUrl,

      })
    },
    watchRouter(){
      switch(this.$route.path){
        case '/user': 
          this.activeLi = 1;
          break;
        case '/user/returnOrExchange':
          this.activeLi = 2;
          break;
        case '/home/refrigerator':
          this.activeLi = 3;
          break;
        case '/home/television':
          this.activeLi = 4;
          break;
      }
    },
    jumpLogistics(val){
      this.$router.push({path: '/personalCenter/logistics', query: {orderNo: val.OrderNo}})
    },
    paymentFun(val){
      this.$router.push({path: '/payment', query: {orderNo: val.OrderNo, money: val.Amount}})
    },
    jumpOrderDetail(val){
      this.$router.push({path: '/personalCenter/orderDetail', query: {orderNo: val.OrderNo}})
    },
    getUserInfo(){
      userInfo().then(res => {
        if(res.data.success){
          this.userData = res.data.response || {}
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleClick(){
      this.getUserOrderList()
    },
    getUserOrderList(){
      let params = {
        type: this.activeName,
        pageIndex: 1,
        pageSize: 10
      }
      if(this.activeName == '1'){
        delete params.type
      }
      UserOrderList(params).then(res =>{
        if(res.data.success){
          this.orderList = res.data.response.data || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.personal{
  // width: 1200px;
  // margin: 0 auto;
  overflow: hidden;
}
.content-box{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
  .aside-box{
    background: #fff;
    margin-right: 20px;
    text-align: left;
    padding: 20px 0;
    h4{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 20px;
      padding: 0 0 20px 20px;
      border-bottom: 1px solid #f4f4f4;
    }
    .nav-box{
      font-size: 16px;
      color: #666666;
      line-height: 16px;
      padding: 0 0 10px 20px;
      li{
        margin: 15px 0;
        cursor: pointer;
        padding-left: 10px;
      }
      .li-active{
        border-left: 3px solid #f40000;
        padding-left: 7px;
        color: #f40000;
        font-weight: bold;
      }
    }
  }
  .main-top{
    display: flex;
    height: 204px;
    margin-bottom: 20px;
    .portrait-box{
      width: 204px;
      background: linear-gradient(90deg, #F73446 0%, #FB6035 100%);
      border-radius: 10px 0px 0px 10px;
      text-align: center;
      padding: 24px 0;
      .portrait{
        width: 80px;
        height: 80px;
        display: inline-block;
        border-radius: 40px;
        background: #fff;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          border-radius: 40px;
        }
      }
      .user-name{
        font-size: 18px;
        line-height: 28px;
        color: #fff;
        margin: 10px 0;
      }
      .user-info{
        color: #fff;
        font-size: 14px;
        span{
          padding: 3px 5px;
          border-radius: 12px;
          border: 1px solid #ffffff;
        }
      }
    }
    .wallet-box{
      flex: 1;
      width: 736px;
      background: #fff;
      border-radius: 0 10px 10px 0;
      text-align: left;
      .wallet{
        padding-left: 16px;
        border-bottom: 1px solid #f4f4f4;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #333;
      }
      .money-box{
        // padding-left: 16px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 153px;
        span{
          display: block;
        }
        .txt-bold{
          font-size: 24px;
          color: #474245;
        }
        .txt999{
          color: #999;
        }
      }
    }
  }
  .main-nav{
    background: #fff;
    border-radius: 10px;
    padding: 20px 0;
    .table-box{
      padding: 0 20px ;
      .tab-header{
        background: #f3f3f3;
        height: 40px;
        line-height: 40px;
        margin-bottom: 20px;
        >span{
          display: inline-block;
        }
      }
      .tab1{
        width: 380px;
        text-align: left;
        padding-left: 20px;
      }
      .tab2{
        width: 100px;
      }
      .tab5{
        width: 200px;
      }
      .goods-list{
        .goods-box{
          border: 1px solid #f3f3f3;
          margin-bottom: 20px;
          .lable{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            background: #f9f9f9;
            color: #f40000;
            line-height: 40px;
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            padding: 0 20px;
            margin-bottom: 20px;
            .rigth-txt{
              cursor: pointer;
              color: #999999;
              font-weight: 500;
            }
            .rigth-txt:hover{
              color: #f40000;
            }
          }
        }
        .goods-item{
          display: flex;
          padding-bottom: 20px;
          padding-left: 20px;
          >span{
            display: inline-block;
          }
          .btn{
            display: block;
            width: 80px;
            margin: 0 auto;
            padding: 3px 5px;
            color: #999;
            cursor: pointer;
          }
          .btn-border{
            border: 1px solid #f40000;
            background: #f40000;
            color: #fff;
            margin-bottom: 10px;
          }
          .goods{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            width: 380px;
            height: 80px;
            .img{
              width: 80px;
              height: 80px;
            }
            .txt-box{
              width: 300px;
              height: 80px;
              padding-left: 10px;
              position: relative;
              text-align: left;
              .txt{
                text-align: left;
                display: inline-block;
                color: #333333;
              }
              .buy-num{
                position: absolute;
                bottom: 0;
                left: 10px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
  
}
.tabs-box /deep/ .el-tabs__nav-scroll {
  padding: 0 20px;
}
.tabs-box /deep/ .el-tabs__item{
  font-size: 20px;
  font-weight: bold;
}
.tabs-box /deep/ .el-tabs__item:hover{
  color: #303133;
}
.tabs-box /deep/ .el-tabs__active-bar{
  background-color: #f40000;
}
.tabs-box /deep/ .is-active{
  color: #f40000;
}
.tabs-box /deep/ .el-submenu /deep/ .el-submenu__title{
  height: 40px;
  line-height: 40px;
}
</style>